export class TipoPlazaModel {

  id: number;
  nombre: string;
  descripcion: string;

  constructor() {
    this.nombre = '';
    this.descripcion = '';
  }
}
